<template>
  <div class="uploader"
    @dragenter="OnDragEnter"
    @dragleave="OnDragLeave"
    @dragover.prevent
    @drop="onDrop"
    :class="{ dragging: isDragging }">
    <div>
      <p>{{$t("uploader.drag")}}</p>
      <p>O</p>
      <div class="file-input">
        <label for="file">{{$t("uploader.choose")}}</label>
        <input type="file" id="file" @change="onInputChange" multiple />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: Object,
    event: String
  },
  data() {
    return {
      isDragging: false,
      filepond:   {},
      dragCount: 0,
      logger:    false,
      index:   0,
      files:  [],
      temporal: {},
      resized: 0,
      readyUpload: false,
      inputs: [],
      width: 1800,
      height: 1200
    };
  },
  watch:    {
    category(value, oldValue) {
      if(value) { }
    }
  },
  methods:  {
    OnDragEnter(e) {
      e.preventDefault();
      this.dragCount++;
      this.isDragging = true;
      return false;
    },
    OnDragLeave(e) {
      e.preventDefault();
      this.dragCount--;
      if(this.dragCount <= 0)
        this.isDragging = false;
    },
    onInputChange(e) {
      const files = e.target.files;
      var index = this.files.length;
      this.readyUpload = false;

      Array.from(files).forEach((file, i) => {
        this.addImage(file, index);
        index++;
      });
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = false;
      const files = e.dataTransfer.files;
      var index = this.files.length;
      this.readyUpload = false;

      Array.from(files).forEach((file, i) => {
        this.addImage(file, index);
        index++;
      });
    },
    addImage(file, index) {
      if(!file.type.match('image.*')) {
        //this.$toastr.e(`${file.name} is not an image`);
        return;
      }
      const img = new Image(), reader = new FileReader(), _this = this;

      this.files.push({
        name: file.name,
        size: file.size,
        type: file.type,
        status: 'queue',
        timestamp: '',
        image: '',
        dimensions: {}
      });

      reader.onload = (e) => {
        img.src = e.target.result;

        img.onload = function() {
          _this.files[index].dimensions = { w: img.width, h: img.height };

          _this.resizePhoto(_this.files[index], e.target.result).then(function(newImg){
            _this.files[index].image = newImg;
            _this.files[index].timestamp = moment(file.lastModified).format("YYYYMMDD_HHmmss");
            _this.resized++;
          });
        };
      };
      reader.readAsDataURL(file);
    },
    resizePhoto(file, base64) {
      var newSize = this.imageSize(file.dimensions),
        width = newSize.width,
        height = newSize.height;

      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        let context = canvas.getContext("2d");
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
          context.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg'));
        }
      });
    },
    isLandscape(size) {
      return (size.w > size.h);
    },
    imageSize(dimensions) {
      var landscape = this.isLandscape(dimensions), height = 0;
      const width = (landscape) ? this.width : this.height;
      const scaleFactor = width / dimensions.w;
      height = dimensions.h * scaleFactor;

      if(this.logger) {
        console.log("Dimesions: ", dimensions.w + ' --- ' + dimensions.h);
        console.log("Landscape: " + landscape);
        console.log("W: " + width);
        console.log("H: " + height);
      }

      return {width: width, height: height};
    },
    base64ToBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]),
        ab = new ArrayBuffer(byteString.length),
        ia = new Uint8Array(ab);

      for(var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {type: 'image/jpeg'});
    },
    videoBase64ToBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]),
        ab = new ArrayBuffer(byteString.length),
        ia = new Uint8Array(ab);

      for(var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {type: 'video/mp4'});
    },
    getFile(timestamp) {
      return this.files.find(file => file.timestamp == timestamp);
    }
  }
}
</script>
